import { render } from "./QcInspection.vue?vue&type=template&id=7c6bd04e&scoped=true"
import script from "./QcInspection.vue?vue&type=script&lang=js"
export * from "./QcInspection.vue?vue&type=script&lang=js"

import "./QcInspection.vue?vue&type=style&index=0&id=7c6bd04e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6bd04e"]])

export default __exports__